import {
	CodeOutlined,
	DashboardOutlined,
	FileTextOutlined,
	LogoutOutlined,
	QrcodeOutlined,
	SettingOutlined,
	UserOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Avatar, Dropdown, Layout, Menu, Modal, Space } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import logoFull from '@/assets/images/logo.png';
import { useUserStore } from '@/store/useUserStore.ts';
import './index.css';

const { Header, Sider, Content } = Layout;

export default function MainLayout() {
	const navigate = useNavigate();
	const location = useLocation();
	const { userInfo, clearAuth } = useUserStore();

	// 菜单配置
	const menuItems: MenuProps['items'] = [
		{
			key: '/dashboard',
			icon: <DashboardOutlined />,
			label: '工作台',
		},
		{
			key: '/file-upload',
			icon: <FileTextOutlined />,
			label: '文件上传',
		},
		{
			key: '/ecommerce-qrcode',
			icon: <QrcodeOutlined />,
			label: '电商H5二维码',
		},
		{
			key: '/dev-config',
			icon: <CodeOutlined />,
			label: '开发配置',
		},
		{
			key: '/settings',
			icon: <SettingOutlined />,
			label: '系统设置',
		},
	];

	// 用户下拉菜单
	const userMenuItems: MenuProps['items'] = [
		{
			key: 'profile',
			icon: <UserOutlined />,
			label: '个人中心',
		},
		{
			key: 'settings',
			icon: <SettingOutlined />,
			label: '账户设置',
		},
		{
			type: 'divider',
		},
		{
			key: 'logout',
			icon: <LogoutOutlined />,
			label: '退出登录',
			danger: true,
		},
	];

	const handleMenuClick = ({ key }: { key: string }) => {
		navigate(key);
	};

	const handleUserMenuClick = ({ key }: { key: string }) => {
		if (key === 'logout') {
			Modal.confirm({
				title: '退出登录',
				content: '确定要退出登录吗？',
				okText: '确定',
				cancelText: '取消',
				onOk: () => {
					clearAuth();
				},
			});
		}
	};

	return (
		<Layout className="main-layout">
			<Header className="main-header">
				<div className="header-left">
					<div className="logo">
						<img src={logoFull} alt="Logo" />
					</div>
				</div>
				<div className="header-right">
					<Dropdown
						menu={{ items: userMenuItems, onClick: handleUserMenuClick }}
						placement="bottomRight"
					>
						<Space className="user-info" style={{ cursor: 'pointer' }}>
							<Avatar src={userInfo?.avatar} icon={<UserOutlined />} />
							<span>{userInfo?.nickname || userInfo?.username}</span>
						</Space>
					</Dropdown>
				</div>
			</Header>
			<Layout>
				<Sider width={200} theme="light">
					<Menu
						mode="inline"
						selectedKeys={[location.pathname]}
						items={menuItems}
						onClick={handleMenuClick}
						style={{ height: '100%', borderRight: 0 }}
					/>
				</Sider>
				<Content className="main-content">
					<Outlet />
				</Content>
			</Layout>
		</Layout>
	);
}
